/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ObjectCategory } from './ObjectCategory'
import {
  ObjectCategoryFromJSON,
  ObjectCategoryFromJSONTyped,
  ObjectCategoryToJSON,
} from './ObjectCategory'
import type { ServiceObject } from './ServiceObject'
import {
  ServiceObjectFromJSON,
  ServiceObjectFromJSONTyped,
  ServiceObjectToJSON,
} from './ServiceObject'

/**
 *
 * @export
 * @interface ServiceListAdmin
 */
export interface ServiceListAdmin {
  /**
   *
   * @type {number}
   * @memberof ServiceListAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof ServiceListAdmin
   */
  readonly catalogUniqueId: string
  /**
   *
   * @type {string}
   * @memberof ServiceListAdmin
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof ServiceListAdmin
   */
  price?: number | null
  /**
   * * `1` - Template 1
   * * `2` - Template 2
   * * `3` - Template 3
   * @type {number}
   * @memberof ServiceListAdmin
   */
  currentTemplate: ServiceListAdminCurrentTemplateEnum
  /**
   *
   * @type {boolean}
   * @memberof ServiceListAdmin
   */
  isVisible?: boolean | null
  /**
   *
   * @type {string}
   * @memberof ServiceListAdmin
   */
  measureUnit?: string | null
  /**
   *
   * @type {ObjectCategory}
   * @memberof ServiceListAdmin
   */
  readonly category: ObjectCategory
  /**
   *
   * @type {ServiceObject}
   * @memberof ServiceListAdmin
   */
  readonly object: ServiceObject
  /**
   *
   * @type {number}
   * @memberof ServiceListAdmin
   */
  readonly locationsAmount: number | null
}

/**
 * @export
 */
export const ServiceListAdminCurrentTemplateEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const
export type ServiceListAdminCurrentTemplateEnum =
  (typeof ServiceListAdminCurrentTemplateEnum)[keyof typeof ServiceListAdminCurrentTemplateEnum]

/**
 * Check if a given object implements the ServiceListAdmin interface.
 */
export function instanceOfServiceListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'catalogUniqueId' in value
  isInstance = isInstance && 'currentTemplate' in value
  isInstance = isInstance && 'category' in value
  isInstance = isInstance && 'object' in value
  isInstance = isInstance && 'locationsAmount' in value

  return isInstance
}

export function ServiceListAdminFromJSON(json: any): ServiceListAdmin {
  return ServiceListAdminFromJSONTyped(json, false)
}

export function ServiceListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    catalogUniqueId: json['catalogUniqueId'],
    name: !exists(json, 'name') ? undefined : json['name'],
    price: !exists(json, 'price') ? undefined : json['price'],
    currentTemplate: json['currentTemplate'],
    isVisible: !exists(json, 'isVisible') ? undefined : json['isVisible'],
    measureUnit: !exists(json, 'measureUnit') ? undefined : json['measureUnit'],
    category: ObjectCategoryFromJSON(json['category']),
    object: ServiceObjectFromJSON(json['object']),
    locationsAmount: json['locationsAmount'],
  }
}

export function ServiceListAdminToJSON(value?: ServiceListAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    price: value.price,
    currentTemplate: value.currentTemplate,
    isVisible: value.isVisible,
    measureUnit: value.measureUnit,
  }
}
